import {SeriesType} from '@dms/api/core';

// Shared so the page and the Documents tab issue an identical query and share one cache entry.
export const DOCUMENT_SERIES_TYPES: SeriesType[] = [
  'workshop/service_order_list',
  'workshop/service_order_offer',
  'workshop/service_order_issue',
  'workshop/service_order_parts_return',
  'workshop/service_order_claim',
  'workshop/service_order',
  'warehouse/fast-track',
];
